var Marionette = require('marionette'),
    Backbone = require('backbone'),
    $ = require('jquery'),
    _ = require('underscore');



module.exports = Marionette.CollectionView.extend({
    id: 'notesCollection',
    childViewEventPrefix: 'noteView', // This is for event forward, not catching on 'child events'
    initialize: function() {

        _.bindAll(this, 'scrollToNote', 'toggleNoteHighlight', 'toggleUserIsDrawing');

        // Flag to capture mouse hover events in the child views:
        // See DVBC-1701 and comment in new note menu
        this.captureChildHoverEvents = true;

        /**
         * Forward events to local notes channel.
         * Could also use Backbone.fwd
         */
        var ch = this.options.channel;
        this.listenTo(this, 'all', function() {
            ch.trigger.apply(ch, arguments);
        });

        ch.reply(this.requests, this);
        ch.comply(this.commands, this);

        Marionette.bindEntityEvents(this, ch, this.subs);

    },
    getChildView: function(note) {
        return note.ViewConstructor;
    },
    childViewOptions: function() {
        return {
          channel: this.options.channel
        };
    },
    subs: {
        'notes:hoveredCanvasNoteChange':    'toggleNoteHighlight',
        'notes:canvasDrawingToggled':       'toggleUserIsDrawing',
        'noteViews:toggleEventListeners':   'toggleEventsListeners',
        'notes:disableNoteViewHoverEvents': 'disableNoteViewHoverEvents',
        'notes:enableNoteViewHoverEvents':  'enableNoteViewHoverEvents'
    },
    toggleEventsListeners: function(isOn) {
        this.children.call((isOn ? 'undelegate' : 'delegate') + 'Events');
    },
    commands: {
        filterNoteViews: function(noteFilterModel) {
            this.children.call('toggleFiltered', noteFilterModel);
        }
    },
    requests: {
        getNoteViewFromModel: function(model) {
            return this.children.findByModel(model);
        }
    },
    onShow: function() {
        this.scrollTop(0); //must be in dom for IE8
    },    
    scrollTop: function(y) {
        this.$el.scrollTop(y);
    },
    scrollToNote: function(note) {
        var $scroll = this.$el.closest('.sp-body'),//todo: should be this -- but changed class to noteCollection, not what scrolls ... or this.$el.parent ...
            noteView = this.children.findByModel(note),
            st = $scroll.scrollTop(),
            elT = noteView.$el.position().top,
            nt = st + elT,
            dt = (nt > st) ?  elT + st : elT - st,
            self = this;
        dt -= 1; //for the 'active border'
        this.isScrolling && $scroll.stop();  /* stop current animations if changed during (shape hover) */
        $scroll.animate({'scrollTop' : dt}, {
            duration: 350,
            easing: 'swing',
            start: function() {
                self.isScrolling = true;
            },
            complete:function() {
                delete self.isScrolling;
            }
        });
    },
    toggleNoteHighlight: function(note, isEntering) { //(comes from canvas highlighted notes, via FV)
        var view = this.children.findByModel(note);
        isEntering && this.scrollToNote(note);
        view.toggleNoteHighlight(isEntering); 
    },
    toggleUserIsDrawing: function(isDrawing, note) { //(from canvas drawing toggle)
        var view = this.children.findByModel(note);
        view.toggleKeyEvents( isDrawing );
    },

    disableNoteViewHoverEvents: function() {
        this.captureChildHoverEvents = false;
    },

    enableNoteViewHoverEvents: function() {
        this.captureChildHoverEvents = true;
    },

    onNoteViewEnterMouseHover: function(view) {

        view.$el.addClass('hovered');

        // See DVBC-1701 and comment in new note menu
        if (!this.captureChildHoverEvents) {
            return;
        }

        if ( view.model.isDrawable() )
            this.options.channel.trigger('notes:toggleShapeHighlight', view.model, {isEntering: true } );

    },

    onNoteViewExitMouseHover: function(view) {

        view.$el.removeClass('hovered');
        if ( view.model.isDrawable() )
            this.options.channel.trigger('notes:toggleShapeHighlight', view.model, {isEntering: false } );


    },


    /**
     * Note: called on page change.
     */
    setNoteViewsNavigability: function(activeNote, pg) {

        var pgNum = pg.get('number'),
            activeNoteIsPgTextAndNew =
                activeNote && activeNote.isPageTextNote() && activeNote.isNew();  //(active note can be null; && exists)

        // Change Page # For New Page Text Note (while creating & on page change)

        if ( activeNoteIsPgTextAndNew ) {

            activeNote.uiModel.set({
                viewerPgNumber: pgNum, //a) set pg number
                navigationEnabled: false //b turn of nav ability
            });

            // DVBC-1764: update the pageId and pageNumber of the actual model so its saved,
            // the way it's reflected in the UI ... could be done higher up but only would
            // occur for this notetype so not a big deal.
            // Could also set these on save from the current page in the viewer.
            // May want silent update of pageNumber and id function on the model if used elsewhere
            activeNote.pageNumber = pgNum;
            activeNote.set( { pageId: pg.get('pageId')}, {silent:true} );

        }

        // Reset navigation ability
        this.collection.each( function(note) {

            if ( !activeNoteIsPgTextAndNew && note !== activeNote) {
                // set navigation enabled to val of: currentPgNumber != active notePage number (active note can be false)
                note.uiModel.set('navigationEnabled', pgNum !== note.pageNumber );
            }
        });
        
    },

    enterPDFMode: function() {

        this.collection.each(function(note) {
            note.uiModel.set({
                navigationEnabled: false, // disallow pg note navigation
                isEditable: !note.isDrawable() // disallow editing of note
            });
        });

    },
    // TODO: do only if last mode was; not big deal ...
    exitPDFMode: function( options ) {
        this.collection.each(function(note) {
            note.uiModel.set({
                navigationEnabled: true,
                isEditable: true //can be set to the page
            });
       });
        options.pagesExist && this.setNoteViewsNavigability( options.activeNote , options.currentPage ); // overwrite ... works but could clean
    },
    /**
     * This has repercussions -- adding and removal aren't silent.
     * Note: non silent add/removes alter the FV.allNotes collection.
     * ( From toggle active note )
     */
    updateActiveNoteViewPostNoteChange: function(actionOpts, isEntering) {

        var note = actionOpts.note,
            prNote = actionOpts.prNote;

        switch (actionOpts.action) {
            case 'createNew':
                this.collection.add(note, {
                    sort: true,
                    at: 0
                });
                break;
            case 'enterEditExisting':
                break;
            case 'isReadingFlashNote':
                this.options.channel.trigger('notes:updateLastFlashPrId', note); /* call on open, not destroy for flashbacks */
                break;
            case 'newCancelled':
            case 'cancelNewFromPageOrViewChange':
                this.collection.remove(prNote); //allow event
                break;
            case 'flashNoteDestructed':
                this.collection.remove(prNote); //allow event
                break;
            case 'saveNew':
            case 'editExisting': //FIXES THE ISSUE OF MODIFYING -- IN THAT CASE LOGIC CURRENTLY BREAKS IN REMOVE AND ADD TO COLLECTION
            case 'editCancelled': //NOTE STAYS OPEN AND SHAPES DOUBLE DRAWN ON CANVAS
            case 'editSavedButNoChanges':
            case 'cancelEditFromPageOrViewChange':
            //fixes issues --- but should prob go through the workflow with double setting of the active note -- (which would overlap)
                view = this.children.findByModel(prNote);
                view.destroy(); //don't call add event !
                this.render();
                break;
        }

        isEntering && this.turnOnNoteEditMode(note);
        isEntering && actionOpts.isNew && this.scrollToNote(note);
        !isEntering && this.turnOffEditModeForAllNotes(actionOpts);

    },
    turnOnNoteEditMode: function(note, opts) {
        var nonActiveNotes = new Backbone.Collection(this.collection.without(note));
        nonActiveNotes.each(function(note) {
            note.uiModel.setEditMode(false, opts);
        });
        note.uiModel.setEditMode(true, opts);
    },
    turnOffEditModeForAllNotes: function(opts) {
        _.invoke( this._getUIModelsOfCollection() , 'setEditMode', false, opts);
    },
    _getUIModelsOfCollection: function() {
        return this.collection.map(function (note) {
            return note.uiModel;
        });
    }

    /**
     * Old comments:
     * - can't overrite on add/remove here, the event already raised to FV.allNotes -- don't trigger on it -- b/c first, FV.allNotes is updated
     * - clone a collection?
     * - separate events to control workflow
     * - don't have them removed on canvas if an option in here exists?
     */

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/views/noteCollectionView.js
 ** module id = 518
 ** module chunks = 0
 **/